import Axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios';
import { deleteUserData, getUserData, setUserData } from './user';
import baseAPI, { TokenResultView } from '../api';
import logger from '../utils/monitor-service';
import { getToken, setToken } from '@wisory-international-ab/login-frontend';

const LanguageMapper: Record<string, string> = {
  en: 'en-US',
  sv: 'sv-SE',
};

export const applyInterceptor = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.request.use((config) => {
    const token = getToken();

    if (config.headers && !config.headers.Authorization && token?.accessToken) {
      config.headers.Authorization = `Bearer ${token.accessToken}`;
    }

    if (config.headers && !config.headers['Accept-Language'] && WISORY_SDK_SETTINGS.LOCALE) {
      config.headers['Accept-Language'] = LanguageMapper[WISORY_SDK_SETTINGS.LOCALE];
    }

    return config;
  });

  const refreshAccessToken = async (): Promise<TokenResultView | null> => {
    try {
      const userData = getUserData();
      if (!userData?.refreshToken) {
        return null;
      }

      const tokenRes = await baseAPI.login.refreshAccessToken({
        refreshToken: userData.refreshToken,
      });

      const tokenSession = tokenRes.data;
      if (!tokenSession || !tokenSession.accessToken || !tokenSession.userId) {
        return null;
      }

      setUserData(tokenSession);
      return tokenSession;
    } catch (err) {
      return null;
    }
  };

  axiosInstance.interceptors.response.use(
    (res) => res,
    async (error: AxiosError) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const originalRequest = error.config as any;

      logger.logError(error, { errorType: 'API_ERROR' });

      if (error?.response?.status === 401) {
        if (!originalRequest._retry) {
          originalRequest._retry = true;
          const token = await refreshAccessToken();

          if (!token) {
            deleteUserData();

            return Promise.reject(error);
          } else {
            setToken(token as any);
          }

          originalRequest.headers['Authorization'] = 'Bearer ' + token.accessToken;
          return Axios(originalRequest as AxiosRequestConfig);
        } else {
          deleteUserData();

          window.location.reload();
        }
      }

      return Promise.reject(error);
    }
  );
};
